import { call, put, select, takeLatest } from "redux-saga/effects";

import {
  lobbyRoomsRequest,
  lobbyRoomsSuccess,
  lobbyRoomsFailure,
  activeUsersSuccess,
  activeUsersFailure,
  activeUsersRequest,
  myTablesSuccess,
  myTablesFailure,
  myTablesRequest,
  createSpecialTableRequest,
  createSpecialTableSuccess,
  createSpecialTableFailure,
} from "./lobbyActions";

import { AxiosResponse } from "axios";
import {
  createSpecialTable,
  getActiveUsersCounter,
  getLobbyRooms,
  getMyActiveTables,
} from "../../services/api";
import { RootState } from "..";

function* fetchLobbyRoomsWorker(action: ReturnType<typeof lobbyRoomsRequest>) {
  try {
    const { start, limit } = action.payload;
    const res: AxiosResponse = yield call<typeof getLobbyRooms>(getLobbyRooms, {
      start,
      limit,
    });

    const items = Array.isArray(res?.data?.items) ? res.data.items : [];
    const total =
      typeof res?.data?.totalCount === "number"
        ? res.data.totalCount
        : items.length;

    console.log("[saga] lobby rooms:", { total, items });
    yield put(lobbyRoomsSuccess({ items, total }));
  } catch (e: any) {
    console.log("[saga] lobby rooms error:", e);
    const msg =
      e?.message || e?.response?.data?.error || "Failed to load lobby rooms";
    yield put(lobbyRoomsFailure(msg));
  }
}

function* fetchActiveUsersOnce() {
  try {
    const count = yield call(getActiveUsersCounter);
    console.log("count in fetchActiveUsersOnce", count);
    console.log("normal", count.normal);
    // const count = normalizeCounterResponse(res);

    yield put(activeUsersSuccess({ count }));
  } catch (e: any) {
    yield put(activeUsersFailure(e?.message || "Failed to load active users"));
  }
}

function* fetchMyTablesWorker() {
  try {
    const res: AxiosResponse = yield call(getMyActiveTables);
    // res.data = { data: { tables: [...], tournaments: [...] } }
    const data = res?.data?.data;
    const tables = Array.isArray(data?.tables) ? data.tables : [];
    const tournaments = Array.isArray(data?.tournaments)
      ? data.tournaments
      : [];

    const items = [
      ...tables.map((t: any) => ({
        ...t,
        isTournamentRoom: false,
      })),

      ...tournaments.map((t: any) => ({
        ...t,
        isTournamentRoom: true,
      })),
    ];

    yield put(myTablesSuccess({ items }));
  } catch (e: any) {
    console.log("[saga] my tables error:", e);
    const msg =
      e?.message || e?.response?.data?.error || "Failed to load my tables";
    yield put(myTablesFailure(msg));
  }
}

function* createSpecialTableWorker(
  action: ReturnType<typeof createSpecialTableRequest>,
) {
  try {
    const auth: RootState["auth"] = yield select((s: RootState) => s.auth);
    const playerId = auth?.user?.id;

    if (!playerId) {
      throw new Error("Missing playerId");
    }

    const payload = {
      playerId: String(playerId),
      stake: action.payload.stake,
      minimalAmount: action.payload.minimalAmount,
      maximalAmount: action.payload.maximalAmount,
      maxSeats: action.payload.maxSeats,
      turnDuration: action.payload.turnDuration,
      isPrivate: action.payload.isPrivate,
    };

    const response = yield call(createSpecialTable, payload);
    console.log("reseponn from VIP in saga", response);
    const tableId =
      response?.data?.id || response?.data?.tableId || response?.id;
    const legacyRoomId = response?.data?.legacyRoomId ?? response?.legacyRoomId;
    console.log("tableId from VIP in saga", tableId);
    console.log("legacyRoomId from VIP in saga", legacyRoomId);
    yield put(createSpecialTableSuccess({ tableId, legacyRoomId }));
  } catch (e: any) {
    console.log("errrorrr upon creating vip table", e);
    const errorCode = e?.response?.data?.code;
    console.log("error code", errorCode);
    let msg = "";

    if (errorCode === 1018) {
      msg = "T_SITE_MODAL_NEW_ROOM_VIP_LIMIT";
    } else if (errorCode === 1017) {
      msg = "T_SITE_MODAL_NEW_ROOM_NOT_ENOUGH_CHIPS";
    } else {
      msg =
        e?.response?.data?.message || e?.message || "Failed to create table";
    }

    yield put(createSpecialTableFailure(msg));
  }
}

export function* lobbyRootSaga() {
  yield takeLatest(lobbyRoomsRequest.type, fetchLobbyRoomsWorker);
  yield takeLatest(activeUsersRequest.type, fetchActiveUsersOnce);
  yield takeLatest(myTablesRequest.type, fetchMyTablesWorker);
  yield takeLatest(createSpecialTableRequest.type, createSpecialTableWorker);
}

export const selectActiveUsersCount = (s: any) =>
  s.lobby.activeUsersCount?.normal || 0;
export const selectVipUsersCount = (s: any) =>
  s.lobby.activeUsersCount?.vip || 0;
export const selectTournamentUsersCount = (s: any) =>
  s.lobby.activeUsersCount?.tournament || 0;
export const selectTotalActiveUsersCount = (s: any) =>
  s.lobby.activeUsersCount?.active || 0;
export const selectActiveUsersLoading = (s: any) => s.lobby.activeUsersLoading;
export const selectActiveUsersError = (s: any) => s.lobby.activeUsersError;
export const selectMyTablesItems = (s: any) => s.lobby.myTablesItems;
export const selectMyTablesLoading = (s: any) => s.lobby.myTablesLoading;
export const selectMyTablesError = (s: any) => s.lobby.myTablesError;
